/* eslint-disable*/

import PropTypes from 'prop-types';

import DesktopScoreItem from './scoreItem';
// TODO: Remove viva for Wohnpreis prodcution
const DesktopComponent = ({
  newScore,
  item,
  viva,
  cultureScore,
  localSupply,
  publicTransport,
  selectedLayer,
}) => (
  <>
    <DesktopScoreItem
      type="wohnlage"
      item={item}
      height={20}
      width={13}
      viva={viva}
      newScore={newScore}
      selectedLayer={selectedLayer}
    />
    <DesktopScoreItem
      type="opnv"
      item={item}
      height={20}
      width={13}
      viva={viva}
      newScore={publicTransport}
      selectedLayer={selectedLayer}
    />
    <DesktopScoreItem
      type="kultur"
      item={item}
      height={20}
      width={13}
      viva={viva}
      newScore={cultureScore}
      selectedLayer={selectedLayer}
    />
    <DesktopScoreItem
      type="Nahversorgung"
      item={item}
      height={20}
      width={13}
      viva={viva}
      newScore={localSupply}
      selectedLayer={selectedLayer}
    />
  </>
);

DesktopComponent.propTypes = {
  viva: PropTypes.number.isRequired,
  newScore: PropTypes.number,
  item: PropTypes.object.isRequired,
  cultureScore: PropTypes.number,
  localSupply: PropTypes.number,
  publicTransport: PropTypes.number,
};

DesktopComponent.defaultProps = {
  newScore: 3,
  cultureScore: 0,
  localSupply: 0,
  publicTransport: 0,
};

export default DesktopComponent;
